export const LOAD_PAYMENTS = 'LOAD_PAYMENTS'
export const LOAD_PAYMENT_STATUS = 'LOAD_PAYMENT_STATUS'
export const LOAD_PAYMENT_TYPES = 'LOAD_PAYMENT_TYPES'